import { isMobile } from 'react-device-detect';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DateSelector.scss';

export const DateSelector = ({
  label,
  initDate,
  setDate,
  minDate,
  maxDate
}) => {
  const handleChange = date => {
    setDate(date);
  };

  return (
    <>
      <h5 className='mb-3'>{label}</h5>
      <DatePicker
        className='form-control mb-2'
        selected={initDate}
        onFocus={e => (e.target.readOnly = isMobile)}
        onBlur={e => (e.target.readOnly = false)}
        onChange={handleChange}
        todayButton='Today'
        showMonthDropdown
        showYearDropdown
        dropdownMode='select'
        minDate={minDate}
        maxDate={maxDate}
        withPortal={isMobile}
      />
      <div className='form-text mb-3'>Date is in the US format mm/dd/yyyy.</div>
    </>
  );
};
